import { createFileRoute } from '@tanstack/react-router';

import { InvestPage } from '@/features/invest/public';
import { requireInvestorSession } from '@/features/investor-login/public';
import { Layout } from '@/features/portal-shell/public';
import { logger } from '@/lib/logger';

interface InvestSearch {
  schemeNo?: string;
  folioNo?: string;
}

const InvestRoute = () => {
  const search = Route.useSearch();
  return (
    <Layout>
      <InvestPage schemeNo={search.schemeNo} folioNo={search.folioNo} />
    </Layout>
  );
};

export const Route = createFileRoute('/invest')({
  staticData: { navSection: 'portfolio' },
  beforeLoad: ({ search }) => {
    requireInvestorSession();

    // The BE takes exactly one identifier: neither leaves it with nothing to resolve, both leave
    // it ambiguous. No UI path produces either, so treat them as unexpected rather than recoverable.
    const identifierCount = [search.schemeNo, search.folioNo].filter(Boolean).length;
    if (identifierCount !== 1) {
      logger.error('invest route received an unexpected identifier combination', { identifierCount });
      throw new Error('Invest route requires exactly one of schemeNo / folioNo');
    }
  },
  // Coerce to string: a numeric folioNo (e.g. 10004894) is parsed as a number by the default
  // search parser, so a `typeof === 'string'` guard would drop it.
  validateSearch: (search: Record<string, unknown>): InvestSearch => ({
    schemeNo: search.schemeNo != null ? String(search.schemeNo) : undefined,
    folioNo: search.folioNo != null ? String(search.folioNo) : undefined,
  }),
  component: InvestRoute,
});
